<div [formGroup]="accountInfo" class="row mx-n3 mb-3">
    <div class="col-md-6 p-3">
        <label class="text-navy-blue font-size-18 font-weight-bold" for="email"
            >Email address</label
        >
        <input
            type="email"
            class="form-control font-size-16 p-0 border-0 bg-transparent"
            id="email"
            formControlName="email"
        />
        <a
            *ngIf="hasPBSAccount && userService.userAccountEditUrl"
            [href]="userService.userAccountEditUrl"
            class="open-user-info-edit"
            rel="noopener noreferrer"
            target="_blank"
        >
            Change Email
            <app-icon [type]="'External-link'"></app-icon>
        </a>
    </div>
    <div class="col-md-6 p-3">
        <label class="text-navy-blue font-size-18 font-weight-bold" for="password">Password</label>
        <input
            type="password"
            class="form-control font-size-16 p-0 border-0 bg-transparent"
            id="password"
            autocomplete="off"
            placeholder="************"
            formControlName="password"
        />
        <a *ngIf="hasPBSAccount" (click)="clickChangePassword()" class="open-user-info-edit">
            Change Password
            <app-icon [type]="'External-link'"></app-icon>
        </a>
    </div>
</div>
